import request from './.request'
/**
 * 基于地块查询种植计划，也就是列出地块，地块上显示附带的种植计划
 * @param {*} e
 * @returns
 */
export function getPlansOnLand(entrId, param) {
  return request({
    url: `/plan?base=land&enterpriseId=${entrId}`,
    method: 'get',
    params: param
  })
}
export function planListSearch(e) {
  return request({
    url: '/plan',
    method: 'get',
    params: e
  })
}
export function planListAdd(e) {
  return request({
    url: '/plan',
    method: 'post',
    data: e
  })
}

export function planListUpdate(e) {
  return request({
    url: '/plan',
    method: 'put',
    data: e
  })
}

export function planListDelete(e) {
  return request({
    url: '/plan/'+e,
    method: 'delete'
  })
}
export function planListProgrammeSearch(e,startTime) {
  return request({
    url: '/plan/'+e,
    method: 'get',
    params:{by: 'land',startTime}
  })
}

export function sendWorksList(e) {
  return request({
    url: '/plan/work-plan',
    method: 'put',
    data:e
  })
}
/**
 *  某一天生产任务查询
 * */
export function taskDateGet(landId,day) {
  return request({
    url: `/work/${landId}/${day}?by=land&restrict=day`,
    method: 'get'
  })
}

/**
 * 任务添加
 * */
export function taskAdd(e) {
  return request({
    url: '/work',
    method: 'post',
    data:e
  })
}
/**
 * 删除任务
 * */
export function taskDelete(e) {
  return request({
    url: `/work/${e}`,
    method: 'delete',
  })
}
/**
 * 阶段查询
 * */
export function stageData(e) {
  return request({
    url: `/plan/by-land-id/${e}`,
    method: 'get',
  })
}
/**
 * 根据生产任务的id查询投入品
 * */
export function inputsData(id) {
  return request({
    url: `/work/${id}/inputs?by=workId`,
    method: 'get',
  })
}
/**
 * 阶段查询
 * */
export function taskUpdate(id,e) {
  return request({
    url: `/work/${id}`,
    method: 'put',
    data:e
  })
}
/**
 *  根据公司id查询库存量大于0的投入品
 * */
export function InputListOfReserve(enterpriseId) {
  return request({
    url:`/work/${enterpriseId}/inputs?by=enterpriseId`,
    method:'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/plan-list.js